// src/components/store/Breadcrumb.js
import { Link } from "react-router-dom";
import "../../static/storecss/StoreBreadcrumb.css";

/**
 * items: array of { label, to? }
 *   - If `to` is provided → rendered as a Link
 *   - Last item (or item without `to`) → rendered as current text
 *
 * Example:
 *   <Breadcrumb items={[
 *     { label: "Store", to: "/store" },
 *     { label: "Boards", to: "/store?category=boards" },
 *     { label: "Development boards", to: "/store?category=development-boards" },
 *     { label: "STM32F103C8T6 Blue Pill" },
 *   ]} />
 */
export default function Breadcrumb({ items = [] }) {
  if (!items.length) return null;

  return (
    <nav className="breadcrumb" aria-label="Breadcrumb">
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <span key={i} className="breadcrumb-item">
            {isLast || !item.to ? (
              <span className="breadcrumb-current" aria-current="page">
                {item.label}
              </span>
            ) : (
              <Link to={item.to} className="breadcrumb-link">
                {item.label}
              </Link>
            )}
            {!isLast && <span className="breadcrumb-sep">/</span>}
          </span>
        );
      })}
    </nav>
  );
}